export default function getFbRtData(tgtUrl, accessToken) {
  return dispatch => {
    let url = tgtUrl + "?auth=" + accessToken;
    return fetch(url, {
      method: "GET"
    })
      .then(res => {
        //console.log(res);
        return res.json();
      })

      .then(parsedRes => {
        return parsedRes;
      })

      .catch(err => {
        console.log(" db initial load s1 " + err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/getFbRtData.js